









































import { computed, createComponent, ref } from "@vue/composition-api";
import { getNavSidebarOptions } from "./navSidebarOptions";
import _ from "lodash";
import { useAccessibleServices } from "./useAccessibleServices";

interface Props {}

export default createComponent<Props>({
  components: {},
  props: {},
  setup(props, ctx) {
    const accessibleServices = useAccessibleServices();

    const onExternalLink = (path: string) => {
      window.location.href = path;
    };

    const options = computed(
      () => accessibleServices.value && getNavSidebarOptions(accessibleServices.value),
    );

    return {
      onExternalLink,
      options,
    };
  },
});
